"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enquireGetOfficeInfo = exports.enquireApiCallToActionToken = exports.enquireApiSubmitToken = exports.EnquireRequestType = void 0;
var Api_1 = require("@/api/remote/Api");
var StorageApi_1 = require("@/api/browser/StorageApi");
var EnquireRequestType;
(function (EnquireRequestType) {
    EnquireRequestType[EnquireRequestType["General"] = 1] = "General";
    EnquireRequestType[EnquireRequestType["Firsthand_Property"] = 2] = "Firsthand_Property";
    EnquireRequestType[EnquireRequestType["Search_Property"] = 3] = "Search_Property";
    EnquireRequestType[EnquireRequestType["Search_International_Property"] = 4] = "Search_International_Property";
    EnquireRequestType[EnquireRequestType["Property_Details"] = 5] = "Property_Details";
    EnquireRequestType[EnquireRequestType["International_Property_Details"] = 6] = "International_Property_Details";
    EnquireRequestType[EnquireRequestType["Building_Details"] = 7] = "Building_Details";
    EnquireRequestType[EnquireRequestType["District_Details"] = 8] = "District_Details";
    EnquireRequestType[EnquireRequestType["List_Property"] = 9] = "List_Property";
    EnquireRequestType[EnquireRequestType["Investors"] = 10] = "Investors";
    EnquireRequestType[EnquireRequestType["Firsthand_Properties"] = 11] = "Firsthand_Properties";
    EnquireRequestType[EnquireRequestType["Search_Property_Listing"] = 12] = "Search_Property_Listing";
})(EnquireRequestType = exports.EnquireRequestType || (exports.EnquireRequestType = {}));
exports.enquireApiSubmitToken = function (enquireRequest, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    var onuid = StorageApi_1.readCookie('onuid');
    var oktid = StorageApi_1.readCookie('oktid');
    enquireRequest.analyticsData = {};
    if (oktid) {
        enquireRequest.analyticsData.trackingId = oktid;
    }
    if (onuid) {
        enquireRequest.analyticsData.userId = onuid;
    }
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/communication/contactus",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: enquireRequest,
    });
};
exports.enquireApiCallToActionToken = function (enquireRequest, languageCode, token) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    var onuid = StorageApi_1.readCookie('onuid');
    var oktid = StorageApi_1.readCookie('oktid');
    enquireRequest.analyticsData = {};
    if (oktid) {
        enquireRequest.analyticsData.trackingId = oktid;
    }
    if (onuid) {
        enquireRequest.analyticsData.userId = onuid;
    }
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/communication/contactusmedia",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: enquireRequest,
    });
};
exports.enquireGetOfficeInfo = function (languageCode) {
    if (process.env.DEV)
        return Promise.resolve({ data: { status: true } });
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/general/getofficeinfo ",
        data: {
            officeIds: [1],
        },
    });
};
